import React from "react";
import { object } from "prop-types";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import pdViewIcon from "./app-icon.svg";

const antIcon = <LoadingOutlined spin style={{ fontSize: 42 }} />;

export const Spinner = ({ style }) => (
  <div
    style={{
      width: "42px",
      height: "42px",
      display: "inline-block",
      background: "white",
      borderRadius: "50%",
      border: "3px solid #ccc",
      position: "relative",
      ...style
    }}
  >
    <img
      src={pdViewIcon}
      alt={"loading"}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "32px",
        height: "32px"
      }}
    />
    <Spin
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
      }}
      indicator={antIcon}
    />
  </div>
);

Spinner.propTypes = {
  style: object
};
